import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import './header.css';
import { VscSettings } from "react-icons/vsc";
import Loadingimg from '../components_root/loadingimg.jsx';
import { db } from "../firebase.js";
import {
  collection,
  query,
  where,
  getDocs,
  onSnapshot
} from "firebase/firestore";
import { CiCalculator2, CiSearch } from "react-icons/ci";
import { useNavigate, useLocation } from "react-router-dom";
import { ImDisplay } from "react-icons/im";
import html2canvas from 'html2canvas';
import { RiAccountCircleLine, } from "react-icons/ri";
import Photosicon from '../assets/photos_icon.png';
import Messageshow from '../message_root/message-show';
import Menu_Popup from "./menu_popup.jsx";
import Menu_Popup_pos from "./menu_popup_pos.jsx";
import { Accounts_authority } from '../accounts_authority_root/accounts_authority.js';
import { Get_website_information } from '../website_root/get_website_information.js';
import { MdOutlineMenu, MdOutlineMenuOpen } from 'react-icons/md';
import Aooz from '../assets/aooz_name.png'; 
export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuOpen_pos, setMenuOpen_pos] = useState(false);
  // Automatically check for logged-in user on page load
  const [isOpen, setIsOpen] = useState(true);
  const [guid, setguid] = useState('');
  //login
  const [userlogin, setuserlogin] = useState(false); // State for popup
  const popupRef = useRef(null);    // Ref for direct DOM manipulation
  const [search, setSearch] = useState(null);
  //get company info
  useEffect(() => {
    const sessiontoken = Cookies.get("sessiontoken");
    const gid = Cookies.get("guid");

    // ❌ Not logged in → redirect
    if (!sessiontoken || !gid) {
      setuserlogin(false);
    } else {
      setuserlogin(true);
      setguid(gid);
    }

    // ✅ Logged in → set guid

  }, [navigate]);

  useEffect(() => {
    const Accounts_authority = async () => {
      try {
        const accountguid = Cookies.get("guid");

        // 🔒 Safety check
        if (!accountguid && userlogin === false) {
          //  navigate("/pricing");
          return;
        }

        const staffRef = collection(
          db,
          "accounts",
          accountguid,
          "accounts_authority"
        );

        const staffQuery = query(
          staffRef,
          where("accountguid", "==", accountguid)
        );

        const staffSnap = await getDocs(staffQuery);

        // ❌ No authority records
        if (staffSnap.empty) {
          return;
        }

        // ✅ Convert Firestore docs → ARRAY
        const staffData = staffSnap.docs.map(doc => doc.data());

        // ✅ Now staffData.length WORKS
        if (staffData.length > 0 && staffData[0]?.companyuid) {

          const hostname = window.location.hostname;
          const isHttps = window.location.protocol === "https:";
          const isLocalhost =
            hostname === "localhost" || hostname === "127.0.0.1";

          const cookieOptions = {
            expires: 1,
            path: "/",
            secure: isHttps,
            sameSite: isHttps ? "None" : "Lax",
            ...(isHttps && !isLocalhost && { domain: ".aooz.in" })
          };

          Cookies.remove("select_company_uid", { path: "/" });
          Cookies.set(
            "select_company_uid",
            staffData[0].companyuid,
            cookieOptions
          );

        } else {
          // 🏢 Authority exists but company not selected
          navigate("/select-company");
        }

      } catch (error) {
        console.error("Accounts authority error:", error);
        //navigate("/pricing");
      }
    };

    Accounts_authority();
  }, [navigate, userlogin]);


  const [websiteinfodata, setwebsiteinfodata] = useState([]);
  useEffect(() => {
    const websiteuid = Cookies.get("website_uid");
    Get_website_information(websiteuid).then((res) => {
      if (res.success) {
        setwebsiteinfodata(res.data || []);
      }
    });
  }, []);


  const create_search = async (e) => {
    if (search == null || search.trim() === "") {
      return; // Exit if search is null or empty
    }
    navigate("/search?id=" + encodeURIComponent(search.trim()));
  };
  const enter_search = async (e) => {
    if (search == null || search.trim() === "") {
      return; // Exit if search is null or empty
    }
    if (e.key === "Enter") {
      navigate("/search?id=" + encodeURIComponent(search.trim()));
    }
  };

  // Check favorites
  const servicetablename = "accountingfinancedb";
  const [favoritesmenudata, setfavoritesmenudata] = useState([]);
  useEffect(() => {
    const guid = Cookies.get("guid");
    const select_company_uid = Cookies.get("select_company_uid");

    if (!select_company_uid || !guid) return;

    const faQuery = query(
      collection(db, servicetablename, select_company_uid, "favorites"),
      where("guid", "==", guid),
      where("status", "==", true)
    );

    // 🔥 Real-time listener
    const unsubscribe = onSnapshot(
      faQuery,
      (faSnap) => {
        if (!faSnap.empty) {
          const favData = faSnap.docs.map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
          }));
          setfavoritesmenudata(favData);
        } else {
          setfavoritesmenudata([]);
        }
      },
      (error) => {
        console.error("Favorites snapshot error:", error);
        setfavoritesmenudata([]);
      }
    );

    // 🧹 Cleanup listener on unmount
    return () => unsubscribe();

  }, [servicetablename]);
  const setcategoryproductsTabInUrl = (tab) => {
    const params = new URLSearchParams(window.location.search);
    params.set("page", tab);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, "", newUrl);

  };
  return (
    <div className="header">
      <div className='header_size'>

        <div className="left_body">
          {location.pathname === '/' ? <div onClick={() => setMenuOpen(true)} className="button-menu cursor "><MdOutlineMenu className="menu_icon" /></div> : ''}
          {location.pathname === '/accounting' ? <div onClick={() => setMenuOpen(true)} className="button-menu cursor "><MdOutlineMenu className="menu_icon" /></div> : ''}
          {/* setMenuOpen_pos */}
          {/* {location.pathname === '/pos-receipt' ? <div onClick={() => setMenuOpen_pos(true)} className="button-menu cursor "><MdOutlineMenu className="menu_icon" /></div> : ''} */}

          <div className="logo-div" title="Go Back Aooz.in" >

            <img
              src={Aooz}

              className="brand-logo"
              onClick={() => window.location.href = '/'}
            />
            <div className="logo-name text-off">Accounting</div>


          </div>
        </div>
        <div className='menus_body'>
          <div
            onClick={() => navigate('/')}
            className={`menubutton-icon  ${location.pathname === '/' ? 'active' : ''}`}
            title="Home"
          >

            <span className="button-text bold fcap">Home</span>
          </div>

          <div
            onClick={() => {
              {
                userlogin === true && (
                  navigate('/pos-receipt')
                )
              }
            }}


            className={`menubutton-icon  ${location.pathname === '/pos-receipt' ? 'active' : ''}`}
            title="POS Receipt"
          >

            <span className="button-text bold  ">POS Receipt</span>
          </div>
          {/* <div
            onClick={() => {
              {
                userlogin === true && (
                  navigate('/pos-billing')
                )
              }
            }} 
            className={`menubutton-icon  ${location.pathname === '/pos-billing' ? 'active' : ''}`}
            title="POS  billing"
          > 
            <span className="button-text bold  ">POS billing</span>
          </div> */}
          {favoritesmenudata.map((row) => (

            <div key={row.id}
              onClick={() => navigate('/' + row.url)}
              className={`menubutton-icon  ${location.pathname === '/' + row.name ? 'active' : ''}`}
              title={row.name}
            >
              {/* {location.pathname === '/pricing' ? <IoPricetag className="icon" /> : <IoPricetagOutline className="icon" />} */}
              <span className="button-text bold fcap">  {row.name}</span>
            </div>

          ))}
          {/* {userlogin === false && (
            <div
              onClick={() => navigate('/pricing')}
              className={`menubutton-icon  ${location.pathname === '/pricing' ? 'active' : ''}`}
              title="Pricing"
            >
 
              <span className="button-text bold fcap">Pricing</span>
            </div>
          )} */}

        </div>
        {/* <div className='search-body'>
          <CiSearch className='search-icon' />
          <input className='search_input text-h1 ' onKeyDown={enter_search} value={search} maxLength={100} onChange={(e) => setSearch(e.target.value)} placeholder='Search '></input>

          <div className='search_btn_div'>
            <VscSettings className='search_btn' onClick={(e) => create_search()} />
          </div>

        </div> */}

        <div className="right_body">
          {/* <div className='searchdiv' onClick={() => navigate('/search')}>

            <CiSearch className='search_icon' /></div> */}

          {/* <div className='itemdiv' onClick={() => navigate('/search')}>
                        <MdOutlineFavoriteBorder className='search_icon' />
                    </div>  
         */}



          {userlogin ? (
            <div className='account-sttings' onClick={() => navigate('/account')}>
              <img
                src={Cookies.get("photoURL") || Photosicon}
                onError={(e) => { e.currentTarget.src = Photosicon; }}
                className="Photos-icon rounded-circle shadow hover"
              />
            </div>
          ) : (
            <div className='account-sttings'>
              <div className='button-ui p-2' onClick={() => navigate('/login')} >    <RiAccountCircleLine className="icon" />Login</div>
            </div>
          )}


          <div className='itemdiv' onClick={() => navigate('/message')}>
            <Messageshow /></div>



          {/* <div className='itemdiv' onClick={() => navigate('/pos-receipt')}>

            <IoStorefrontOutline  className='icon_img_logo' /></div> */}


        </div>

      </div>
      <div className='hd-tabs-body'>
        <div className='ui-grid-100'>

        </div>
      </div>
      {/* <div className='hd-tabs-body'>
              <div className='container_size'>
                <div className='post_div'>   
                  <div className='ui-grid-tabs'>
            
                    <div className="ui-items-tabs text-h3 cursor center">
                      <table>
                        <tr>
                     
                          <td><div onClick={() => navigate('/phonebook')}>Phonebook</div></td>
                        </tr>
                      </table>
                    </div>
            
                    <div className="ui-items-tabs  text-h3 cursor center">
                      <table>
                        <tr>
                   
                          <td><div onClick={() => navigate('/image-to-pdf')}>Image to pdf</div></td>
                        </tr>
                      </table>
                    </div>
            
                    <div className="ui-items-tabs  text-h3 cursor center">
                      <table>
                        <tr>
                
                          <td><div onClick={() => navigate('/favicon-generator')}>Favicon</div></td>
                        </tr>
                      </table>
                    </div>
            
                    <div className="ui-items-tabs  text-h3 cursor center">
                      <table>
                        <tr>
              
                          <td><div onClick={() => navigate('/word-counter')}>Word counter</div></td>
                        </tr>
                      </table>
                    </div>
            
                    <div className="ui-items-tabs text-h3 cursor center">
                      <table>
                        <tr>
             
                          <td><div onClick={() => navigate('/typing-master')}>Typing master</div></td>
                        </tr>
                      </table>
                    </div>
            
                  </div>
                </div>
              </div>
            </div> */}
      <Menu_Popup isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <Menu_Popup_pos isOpen={menuOpen_pos} onClose={() => setMenuOpen_pos(false)} />
    </div >
  );
}